@if (!loading()) {
  <h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    @if (newRide) {
      <span>Nieuwe rit</span>
    } @else if (!newRide && !data.ride.isRetour) {
      <span> Rit bewerken </span>
    } @else if (!newRide && data.ride.isRetour && !data.ride.retourParentId) {
      <span> Retour rit aanmaken </span>
    } @else if (!newRide && data.ride.isRetour && data.ride.retourParentId) {
      <span> Retourrit bewerken </span>
    }
    <div class="title-buttons">
      @if (!newRide && !data.retourGenerating) {
        <button
          mat-icon-button
          aria-label="Rit verwijderen"
          (click)="deleteRide()"
          matTooltip="Rit verwijderen"
          [disabled]="showPassengerForm()"
        >
          <mat-icon>delete</mat-icon>
        </button>
      }
      @if (!data.retourGenerating) {
        <button mat-icon-button aria-label="Sluiten" mat-dialog-close>
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
  </h1>
}
@if (!loading()) {
  <div mat-dialog-content class="edit-ride-dialog-content">
    @if (rideReadOnly()) {
      <mat-error>Deze rit heeft al plaatsgevonden en kan niet meer worden bewerkt.</mat-error>
    }
    @if (rideForm) {
      <mat-tab-group [selectedIndex]="selectedTabIndex">
        <mat-tab>
          <ng-template mat-tab-label>
            <div class="tab-label">
              @if (Object.keys(userWarnings()).length > 0) {
                <mat-icon class="warning-icon" matTooltip="Er zijn 1 of meerdere problemen bij de passagiers"
                  >warning</mat-icon
                >
              }
              @if (automaticCapacityExceeded()) {
                <mat-icon class="warning-icon" matTooltip="De capaciteit van de rit is overschreden">warning</mat-icon>
              }
              <span>Passagiers ({{ users().length }})</span>
            </div>
            @if (users().length + (coDriverId() ? 1 : 0) < seatsTaken()) {
              <span class="tab-label-extra"
                >+ {{ seatsTaken() - users().length - (coDriverId() ? 1 : 0) }} begeleider{{
                  seatsTaken() - users().length - (coDriverId() ? 1 : 0) > 1 ? 's' : ''
                }}</span
              >
            }
          </ng-template>
          <ng-container *ngTemplateOutlet="usersTemplate"></ng-container>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <div class="tab-label">
              @if (
                rideForm.invalid ||
                (characteristicsStatus && characteristics().length < 1) ||
                getPrivateVehicleEligibilityError() !== null
              ) {
                <mat-icon class="warning-icon" matTooltip="Er zijn 1 of meerdere problemen bij de rit"
                  >warning</mat-icon
                >
              }
              <span>Ritinformatie</span>
            </div>
          </ng-template>
          <ng-container *ngTemplateOutlet="rideTemplate"></ng-container>
        </mat-tab>
      </mat-tab-group>
    }
  </div>
  <div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false">Annuleren</button>
    <button
      mat-flat-button
      [disabled]="
        !rideForm.valid ||
        (!this.data.ride.automaticallyPlanned && (this.availableSeats() ?? 0) < 0) ||
        (this.data.ride.automaticallyPlanned && automaticCapacityExceeded()) ||
        Object.keys(userWarnings()).length > 0 ||
        (characteristicsStatus && this.characteristics().length < 1) ||
        getPrivateVehicleEligibilityError() !== null ||
        rideReadOnly() ||
        showPassengerForm()
      "
      [class.spinner]="saving()"
      (click)="!saving() ? save() : null"
    >
      Opslaan
    </button>
  </div>
} @else {
  <div mat-dialog-content class="content-spinner">
    <mat-spinner></mat-spinner>
  </div>
}

<ng-template #usersTemplate>
  <form [formGroup]="rideForm" class="ride-form">
    <div class="users">
      @if (!showPassengerForm()) {
        <div class="users-header">
          <div class="search-section">
            <div class="filters" [formGroup]="filterForm">
              <mat-chip-listbox class="chips" [disabled]="filterForm.disabled">
                <mat-chip-option
                  class="chip primary-color"
                  (click)="setSearchFilter(filterOption.Name)"
                  (selectionChange)="preventChipUnselect($event)"
                  aria-label="Filter op naam"
                  [attr.aria-selected]="this.filterForm.value.filter === filterOption.Name"
                  [selected]="this.filterForm.value.filter === filterOption.Name"
                >
                  Naam
                </mat-chip-option>
                <mat-chip-option
                  class="chip primary-color"
                  (click)="setSearchFilter(filterOption.Email)"
                  (selectionChange)="preventChipUnselect($event)"
                  aria-label="Filter op e-mail"
                  [attr.aria-selected]="this.filterForm.value.filter === filterOption.Email"
                  [selected]="this.filterForm.value.filter === filterOption.Email"
                >
                  E-mail
                </mat-chip-option>
                <mat-chip-option
                  class="chip primary-color"
                  (click)="setSearchFilter(filterOption.Address)"
                  (selectionChange)="preventChipUnselect($event)"
                  aria-label="Filter op adres"
                  [attr.aria-selected]="this.filterForm.value.filter === filterOption.Address"
                  [selected]="this.filterForm.value.filter === filterOption.Address"
                >
                  Adres
                </mat-chip-option>
                <mat-chip-option
                  class="chip primary-color"
                  (click)="setSearchFilter(filterOption.PhoneNumber)"
                  (selectionChange)="preventChipUnselect($event)"
                  aria-label="Filter op telefoon"
                  [attr.aria-selected]="this.filterForm.value.filter === filterOption.PhoneNumber"
                  [selected]="this.filterForm.value.filter === filterOption.PhoneNumber"
                >
                  Telefoon
                </mat-chip-option>
              </mat-chip-listbox>
            </div>
            <mat-form-field class="search-field mat-form-field-no-subscript">
              <mat-label>Zoeken</mat-label>
              <input
                #userSearch
                matInput
                [formControl]="searchCtrl"
                placeholder="Zoeken"
                [matAutocomplete]="auto"
                matAutocompletePosition="below"
              />
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="changeUser(undefined, $event.option.value)">
                @for (user of filteredPassengers(); track user.id) {
                  <mat-option [value]="user" class="multilines">
                    <div class="align-text-to-bottom">
                      <div class="flex-one">
                        @if (user.streetName) {
                          <p>
                            <b>{{ user.name }} ({{ user.credits }})</b>
                            {{ user.streetName }} {{ user.houseNumber
                            }}{{ user.houseNumberAddition ? '-' + user.houseNumberAddition : '' }}, {{ user.postal }}
                            {{ user.city }}
                          </p>
                        }
                        @if (!user.streetName) {
                          <p>
                            <b>{{ user.name }} ({{ user.credits }})</b>
                          </p>
                        }
                        <p>
                          @if (user.phoneNumber) {
                            <span>{{ user.phoneNumber }}</span>
                          }
                          @if (user.phoneNumber && user.email) {
                            <span>,&nbsp;</span>
                          }
                          @if (user.email) {
                            <span> {{ user.email }}</span>
                          }
                        </p>
                      </div>
                      @if (user.paymentFailed || (!user.currentPlan && user.credits! < 5)) {
                        <span
                          matTooltip="{{
                            user.paymentFailed
                              ? 'Er is een fout opgetreden bij het betalen.'
                              : 'De passagier heeft minder dan 5 credits'
                          }}"
                          [matTooltipPosition]="'above'"
                        >
                          <mat-icon class="warn-icon">error</mat-icon>
                        </span>
                      }
                    </div>
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
          @if (this.users().length > 0) {
            <div class="users-button-wrapper">
              <button mat-flat-button class="secondary-color" (click)="onMapsClick($event, getRideData())">
                Route bekijken
              </button>
            </div>
          }
        </div>

        @if (users().length === 0) {
          <p class="no-users-yet">Er zijn nog geen passagiers in de rit.</p>
        } @else {
          <div class="users-list">
            @for (timeSlot of timeSlots(); track i; let i = $index) {
              <div class="time-slot">
                <div class="time-slot-heading">
                  <p class="time-slot-title">
                    {{ moment(timeSlot.time).format('HH:mm') }}
                    @if (data.ride.automaticallyPlanned && automaticOccupancy()[i]; as occupancy) {
                      @if (occupancy.availableSeats < 0) {
                        <mat-icon class="warning-icon" matTooltip="De capaciteit van de rit is overschreden"
                          >warning</mat-icon
                        >
                      }
                    }
                  </p>
                  @if (data.ride.automaticallyPlanned && automaticOccupancy()[i]; as occupancy) {
                    <div class="occupancy-change">
                      @if (occupancy.dropoffCount > 0) {
                        <span>{{
                          occupancy.dropoffCount === 1
                            ? '1 zitplaats is vrijgekomen'
                            : occupancy.dropoffCount + ' zitplaatsen zijn vrijgekomen'
                        }}</span>
                      }
                      @if (occupancy.pickupCount > 0) {
                        <span>{{
                          occupancy.pickupCount === 1
                            ? '1 zitplaats is ingenomen'
                            : occupancy.pickupCount + ' zitplaatsen zijn ingenomen'
                        }}</span>
                      }
                      @if (occupancy.availableSeats === 1 || occupancy.availableSeats === -1) {
                        <span>Er is nu {{ occupancy.availableSeats }} zitplaats beschikbaar</span>
                      } @else {
                        <span>Er zijn nu {{ occupancy.availableSeats }} zitplaatsen beschikbaar</span>
                      }
                    </div>
                  }
                </div>
                @for (location of timeSlot.locations; track location) {
                  @if (getUserById(users(), location.userId); as user) {
                    <mat-card class="user-card">
                      <div class="user-wrapper">
                        <div class="title-wrapper">
                          <p class="card-title">
                            @if (userWarnings()?.[location.userId]?.[location.type]) {
                              <mat-icon
                                class="warning-icon"
                                matTooltip="{{ userWarnings()?.[location.userId]?.[location.type] }}"
                                matTooltipClass="mat-icon-tooltip"
                              >
                                warning
                              </mat-icon>
                            } @else if (hasUserWarnings(location.userId)) {
                              <mat-icon
                                class="warning-icon"
                                matTooltip="{{ Object.values(userWarnings()?.[location.userId])[0] }}"
                                matTooltipClass="mat-icon-tooltip"
                              >
                                warning
                              </mat-icon>
                            }
                            {{ location.type === 'from' ? 'Ophalen' : 'Afzetten' }}
                          </p>
                          <div class="buttons">
                            @if (timeSlot.locations.length > 1) {
                              <button
                                type="button"
                                [disabled]="rideReadOnly() || timeSlot.locations.indexOf(location) === 0"
                                mat-icon-button
                                aria-label="Passagier naar boven verplaatsen"
                                (click)="moveOrder('up', i, timeSlot.locations.indexOf(location))"
                                matTooltip="Naar boven verplaatsen"
                              >
                                <mat-icon>arrow_drop_up</mat-icon>
                              </button>
                              <button
                                type="button"
                                [disabled]="
                                  rideReadOnly() ||
                                  timeSlot.locations.indexOf(location) === timeSlot.locations.length - 1
                                "
                                mat-icon-button
                                aria-label="Passagier naar beneden verplaatsen"
                                (click)="moveOrder('down', i, timeSlot.locations.indexOf(location))"
                                matTooltip="Naar beneden verplaatsen"
                              >
                                <mat-icon>arrow_drop_down</mat-icon>
                              </button>
                            }
                            <button
                              type="button"
                              mat-icon-button
                              aria-label="Passagier verplaatsen"
                              (click)="moveUser(user)"
                              [disabled]="rideReadOnly()"
                              matTooltip="Passagier verplaatsen"
                            >
                              <mat-icon>transfer_within_a_station</mat-icon>
                            </button>
                            <button
                              type="button"
                              mat-icon-button
                              aria-label="Passagier bewerken"
                              (click)="changeUser(users().indexOf(user), user)"
                              [disabled]="rideReadOnly()"
                              matTooltip="Passagier bewerken"
                            >
                              <mat-icon>edit</mat-icon>
                            </button>
                            <button
                              type="button"
                              mat-icon-button
                              aria-label="Passagier verwijderen"
                              (click)="removeUserConfirm(users().indexOf(user))"
                              [disabled]="rideReadOnly()"
                              matTooltip="Passagier verwijderen"
                            >
                              <mat-icon>delete</mat-icon>
                            </button>
                          </div>
                        </div>
                        <p class="vehicle-entry-duration-wrapper">
                          @if (
                            (location.type === 'from' && (user?.vehicleEntryDuration ?? 0) > 0) ||
                            (location.type === 'to' && (user?.vehicleExitDuration ?? 0) > 0)
                          ) {
                            <span
                              >({{
                                location.type === 'from'
                                  ? (user.vehicleEntryDuration !== 1
                                      ? user.vehicleEntryDuration + ' minuten'
                                      : user.vehicleEntryDuration + ' minuut') + ' instaptijd'
                                  : (user.vehicleExitDuration !== 1
                                      ? user.vehicleExitDuration + ' minuten'
                                      : user.vehicleExitDuration + ' minuut') + ' uitstaptijd'
                              }})</span
                            >
                          }
                        </p>
                        <div class="user-title-wrapper">
                          <p class="user-title">{{ user.title }}</p>
                          @if (user.phoneNumber && user.phoneNumber !== '') {
                            <p>
                              (
                              <a href="tel:{{ user.phoneNumber }}">{{ user.phoneNumber }}</a>
                              )
                            </p>
                          }
                        </div>
                        @if (user.rideProduct && user.rideProduct?.id !== data?.ride?.rideProduct?.id) {
                          <div>
                            Aangepaste ritprijs: {{ user.rideProduct.name }} - {{ user.rideProduct.cost }} Credits
                          </div>
                        }
                        @if (user.remarks) {
                          <div class="comment">
                            <span class="comment-type">Opmerking (Planner)</span><br />
                            {{ user.remarks }}
                          </div>
                        }
                        @if (particularities) {
                          <div class="icons">
                            @for (particularity of particularities; track particularity.id) {
                              @if (user?.particularityIds?.includes(particularity.id ?? '')) {
                                <div class="icon active" [matTooltip]="particularity.name">
                                  <mat-icon [svgIcon]="particularity.id ?? ''"></mat-icon>
                                </div>
                              }
                            }
                          </div>
                        }
                        <a
                          class="location-link"
                          [href]="'http://maps.google.com/?q=' + location.fullLocation"
                          target="_blank"
                        >
                          <mat-icon>location_on</mat-icon>
                          {{ location.fullLocation }}
                        </a>
                      </div>
                    </mat-card>
                  }
                }
              </div>
            }
          </div>
        }
      } @else {
        <div class="passenger-form-wrapper">
          <app-user-ride
            [data]="getUserRideDialogData()"
            (added)="onUserFormAdded($event)"
            (canceled)="onUserFormCanceled()"
          ></app-user-ride>
        </div>
      }
    </div>
  </form>
</ng-template>

<ng-template #rideTemplate>
  <form [formGroup]="rideForm" class="ride-form">
    <div class="field-group">
      <mat-form-field>
        <mat-label>Voertuig</mat-label>
        <mat-select formControlName="vehicleId" (selectionChange)="vehicleChanged()" cdkFocusInitial>
          @for (vehicle of vehicles(); track vehicle.id) {
            <mat-option
              [value]="vehicle.id"
              [disabled]="
                !!privateVehicleEligibilityErrors()[vehicle.id] ||
                (preserveHistoricalVehicleAssignment() && vehicle.id === data.ride.vehicleId)
              "
            >
              {{ vehicle.name }}
            </mat-option>
          }
        </mat-select>
        @if (selectedVehicle() && data.ride.automaticallyPlanned) {
          <mat-hint class="seats"
            >Totale capaciteit: <span>{{ selectedVehicle()?.['seats'] }} zitplaatsen</span></mat-hint
          >
        } @else if (selectedVehicle() && availableSeats() !== undefined) {
          <mat-hint class="seats">
            Vrije plaatsen in de rit <span>{{ availableSeats() }}/{{ selectedVehicle()?.['seats'] }}</span>
          </mat-hint>
        }
        @if (rideForm.controls.vehicleId.hasError('required')) {
          <mat-error>Dit veld is verplicht.</mat-error>
        } @else if (rideForm.controls.vehicleId.hasError('seatsValidator')) {
          <mat-error
            >{{
              selectedVehicle()?.['seats'] === 1
                ? 'Er kan maar 1 persoon met dit voertuig mee'
                : 'Er kunnen maar ' + selectedVehicle()?.['seats'] + ' personen met dit voertuig mee'
            }}.</mat-error
          >
        }
        @if (getPrivateVehicleEligibilityError(); as privateVehicleEligibilityError) {
          <mat-error>{{ privateVehicleEligibilityError }}</mat-error>
        }
      </mat-form-field>
      @if (showRideProduct) {
        <mat-form-field>
          <mat-label>Ritprijs</mat-label>
          <input type="text" placeholder="Zoeken" matInput formControlName="rideProduct" [matAutocomplete]="products" />
          <mat-icon matSuffix>arrow_drop_down</mat-icon>
          <mat-autocomplete #products="matAutocomplete">
            @for (product of filteredRideProductOptions(); track product.id) {
              <mat-option [value]="product.name">
                {{ product.name }}
              </mat-option>
            }
          </mat-autocomplete>
          @if (rideForm.controls.rideProduct.hasError('required')) {
            <mat-error>Dit veld is verplicht.</mat-error>
          }
          @if (rideForm.controls.rideProduct.hasError('invalidProduct')) {
            <mat-error>Kies een geldige prijs.</mat-error>
          }
        </mat-form-field>
      }
    </div>
    <p class="form-title">Datum en Tijd</p>
    <mat-form-field class="date">
      <mat-label>Datum</mat-label>
      <input
        matInput
        [matDatepicker]="date"
        autocomplete="off"
        required
        (dateChange)="dateUpdated('date', $event.value)"
        formControlName="rideDate"
      />
      <mat-datepicker-toggle matSuffix aria-label="Kalender openen" [for]="date"></mat-datepicker-toggle>
      <mat-datepicker #date></mat-datepicker>
      @if (rideForm.controls.rideDate.hasError('required')) {
        <mat-error>Dit veld is verplicht.</mat-error>
      } @else if (rideForm.controls.rideDate.hasError('dateRangeMin')) {
        <mat-error>De datum mag niet in het verleden liggen.</mat-error>
      } @else if (rideForm.controls.rideDate.hasError('dateRangeMax')) {
        <mat-error>De datum mag niet later zijn dan {{ moment().add(2, 'year').format('DD-MM-YYYY') }}.</mat-error>
      }
    </mat-form-field>
    <p class="form-subtitle">Start- en eindtijd</p>
    <div class="field-group">
      <mat-form-field class="hour">
        <mat-label>Startuur</mat-label>
        <mat-select formControlName="startHour" (selectionChange)="dateUpdated('start')">
          @for (hour of hours(); track hour) {
            <mat-option [value]="hour">{{ hour }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="minute">
        <mat-label>Startminuut</mat-label>
        <mat-select formControlName="startMinute" (selectionChange)="dateUpdated('start')">
          @if (rideForm.controls.startMinute.value % 5 !== 0) {
            <mat-option [value]="rideForm.controls.startMinute.value" class="hide-option">{{
              rideForm.controls.startMinute.value < 10
                ? '0' + rideForm.controls.startMinute.value
                : rideForm.controls.startMinute.value
            }}</mat-option>
          }
          @for (minute of minutes(); track minute) {
            <mat-option [value]="minute.val">{{ minute.text }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="hour">
        <mat-label>Einduur</mat-label>
        <mat-select formControlName="endHour" (selectionChange)="dateUpdated('end')">
          @for (hour of hours(); track hour) {
            <mat-option [value]="hour">{{ hour }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="minute">
        <mat-label>Eindminuut</mat-label>
        <mat-select formControlName="endMinute" (selectionChange)="dateUpdated('end')">
          @if (rideForm.controls.endMinute.value % 5 !== 0) {
            <mat-option [value]="rideForm.controls.endMinute.value" class="hide-option">{{
              rideForm.controls.endMinute.value < 10
                ? '0' + rideForm.controls.endMinute.value
                : rideForm.controls.endMinute.value
            }}</mat-option>
          }
          @for (minute of minutes(); track minute) {
            <mat-option [value]="minute.val">{{ minute.text }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    @if (maxRideMinutesExceeded() && !rideReadOnly()) {
      <mat-error
        >De rit van een passagier mag niet langer dan
        {{ dataStore.generalSettings.maxPassengerRideMinutes ?? 45 }} minuten duren.</mat-error
      >
    } @else if (timeHasPassed() && !rideReadOnly()) {
      <mat-error>De gewenste start- of eindtijd is al voorbij.</mat-error>
    }
    @if (characteristicsStatus) {
      <div class="characteristics-wrapper">
        <mat-form-field class="mat-form-field-no-subscript">
          <mat-label>Kenmerken</mat-label>
          <mat-chip-grid #chipList required [disabled]="rideReadOnly()">
            @for (characteristic of characteristics(); track characteristic) {
              <mat-chip-row (removed)="removeCharacteristic(characteristic)" [removable]="!rideReadOnly()">
                {{ characteristic }}
                <button matChipRemove [disabled]="rideReadOnly()">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            }
            <input
              placeholder="Nieuw kenmerk..."
              #characteristicInput
              [formControl]="characteristicCtrl"
              [matAutocomplete]="auto"
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="addCharacteristic($event)"
            />
          </mat-chip-grid>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedCharacteristic($event)">
            @for (characteristic of filteredCharacteristics(); track characteristic) {
              <mat-option [value]="characteristic">
                {{ characteristic }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <mat-error>
          @if (characteristics().length < 1 && characteristicCtrl.touched) {
            Dit veld is verplicht.
          }
        </mat-error>
      </div>
    }
    <mat-form-field>
      <mat-label>Opmerking (Rit)</mat-label>
      <textarea formControlName="comments" matInput></textarea>
    </mat-form-field>
    @if (activateSignalColor) {
      <div class="toggle-wrapper">
        <mat-slide-toggle formControlName="special"> Bijzondere rit</mat-slide-toggle>
        @if (!signalColorIsPresent) {
          <mat-error class="slide-toggle-error">Kies een signaalkleur bij de instellingen.</mat-error>
        }
      </div>
    }
    @if (usesDriverPlanning) {
      <p class="form-title">Chauffeur</p>
      @if (driverId() && driverName()) {
        <mat-form-field>
          <mat-label>Chauffeur</mat-label>
          <input type="text" [value]="driverName()" matInput readonly />
        </mat-form-field>
      } @else if (!driverId() && !ignoreDriverStatus) {
        <p>Er is nog geen chauffeur voor dit dagdeel gepland.</p>
      }
      @if (dataStore.generalSettings.coDriverEnabled) {
        <p class="form-title">Bijrijder</p>
        @if (coDriverId() && coDriverName()) {
          <mat-form-field>
            <mat-label>Bijrijder</mat-label>
            <input type="text" [value]="coDriverName()" matInput readonly />
          </mat-form-field>
        } @else if (!coDriverId() && !ignoreDriverStatus) {
          <p>Er is nog geen bijrijder voor dit dagdeel gepland.</p>
        }
      }
    }
  </form>
</ng-template>
